module.exports = __webpack_public_path__ + "img/pop_wallet_logo_tokenpocket@2x.4fe77770.png";